// extracted by mini-css-extract-plugin
export var body1 = "fontStyles-module__body1___DgQwx";
export var body2 = "fontStyles-module__body2___xywZZ";
export var body3 = "fontStyles-module__body3___YzyMm";
export var caption1 = "fontStyles-module__caption1___dTYEA";
export var headline1 = "fontStyles-module__headline1___Hflzh";
export var headline2 = "fontStyles-module__headline2___ha2eL";
export var headline3 = "fontStyles-module__headline3___ge8V7";
export var largeTitle = "fontStyles-module__largeTitle___UEc6o";
export var proximaNova = "fontStyles-module__proximaNova___w4OHg";
export var subhead2 = "fontStyles-module__subhead2___NwrWw";
export var title1 = "fontStyles-module__title1___lqJ7j";
export var title2 = "fontStyles-module__title2___LoH2M";